import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import Pagination from 'general/components/Pagination';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import './index.css';
import LoadingOverlay from 'general/components/LoadingOverlay';

Table.prototype = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  maxHeight: PropTypes.number.isRequired,
  values: PropTypes.func.isRequired,
};
function Table(props) {
  let { columns, data, maxHeight, values, colSpan, progressPending } = props;
  const [selected, setSelected] = useState({});
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  useEffect(() => {
    let lstselected = {};
    data?.map((item, index) => {
      lstselected[index] = false;
    });
    setSelected(lstselected);
  }, [data]);

  useEffect(() => {
    if (selected && data) values(data.filter((item, index) => selected[index] === true));
  }, [selected]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  async function sort(type, sortedBy) {
    switch (type) {
      case 'date':
        sortDate(sortedBy);
        break;
      case 'number':
        sortNumber(sortedBy);
        break;
    }
  }

  async function sortDate(sortedBy) {
    let lst = [...data];
    let isAscending = true;
    let sortData = lst.sort((a, b) => {
      let aValue = new Date(
        a
          .find((item) => item.id == sortedBy)
          ['value'].split('/')
          .reverse()
          .join('/')
      );
      let bValue = new Date(
        b
          .find((item) => item.id == sortedBy)
          ['value'].split('/')
          .reverse()
          .join('/')
      );

      if (isAscending) {
        if (aValue < bValue) {
          return -1;
        }
        if (aValue > bValue) {
          return 1;
        }
      } else {
        if (aValue < bValue) {
          return 1;
        }
        if (aValue > bValue) {
          return -1;
        }
      }
      return 0;
    });

    console.log(sortData);
  }
  async function sortNumber() {
    let lst = [...data];
    let sortedData = lst.sort((a, b) => {
      console.log(a);

      let aValue = a.find((item) => item.id == 'value')['value'];
      let bValue = b.find((item) => item.id == 'value')['value'];

      if (isAscending) {
        if (aValue < bValue) {
          return -1;
        }
        if (aValue > bValue) {
          return 1;
        }
      } else {
        if (aValue < bValue) {
          return 1;
        }
        if (aValue > bValue) {
          return -1;
        }
      }
      return 0;
    });
    console.log(sortedData);
  }

  return (
    <div
      className="relative shadow-md sm:rounded-lg"
      style={{ maxHeight: `${maxHeight + 5}vh`, overflow: 'hidden' }}
    >
      <div style={{ maxHeight: `${maxHeight}vh`, overflow: 'auto' }}>
        {progressPending == true ? (
          <table className="w-full text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              <tr>
                <th scope="col" className="p-4">
                  <div className="flex items-center">
                    <input
                      checked={
                        Object.keys(selected).length > 0 &&
                        Object.keys(selected).every((key) => selected[key] === true)
                      }
                      style={{ accentColor: '#1c64f2' }}
                      type="checkbox"
                      className="form-checkbox text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      onChange={(e) => {
                        const value = e.target.checked;
                        let lstSelected = { ...selected };
                        Object.keys(selected).map((key) => {
                          lstSelected[key] = value;
                        });
                        setSelected(lstSelected);
                      }}
                    />
                  </div>
                </th>
                {columns?.map((column, index) => {
                  return (
                    <th key={index} scope="col" className="px-6 py-3">
                      <div className="flex items-center">
                        {column.name}
                        {column.sort && (
                          <a>
                            <svg
                              className="w-3 h-3 ms-1.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                            </svg>
                          </a>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="text-center">
              <tr>
                <td colSpan={columns.length + 1}>
                  <div className="flex flex-col justify-center items-center h-full">
                    <LoadingOverlay message={'Đang Lấy dữ liệu'} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <table className="w-full text-left rtl:text-right dark:text-gray-400">
            <thead className="text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              <tr>
                <th scope="col" className="p-4">
                  <div className="flex items-center">
                    <input
                      checked={
                        Object.keys(selected).length > 0 &&
                        Object.keys(selected).every((key) => selected[key] === true)
                        // console.log(selected);
                      }
                      style={{ accentColor: '#1c64f2' }}
                      type="checkbox"
                      className="form-checkbox text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      onChange={(e) => {
                        const value = e.target.checked;
                        let lstSelected = { ...selected };
                        Object.keys(selected).map((key) => {
                          lstSelected[key] = value;
                        });
                        setSelected(lstSelected);
                      }}
                    />
                  </div>
                </th>
                {columns?.map((column, index) => {
                  return (
                    <th key={index} scope="col" className="px-6 py-3">
                      <div className="flex items-center">
                        {column.name}
                        {column.sort && (
                          <a onClick={() => sort(column.type, column.sortedBy)}>
                            <svg
                              className="w-3 h-3 ms-1.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                            </svg>
                          </a>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data
                ?.slice(
                  rowsPerPage * (currentPage - 1),
                  data.length >= rowsPerPage * currentPage ? rowsPerPage * currentPage : data.length
                )
                .map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="hoverrow"
                      style={{ backgroundColor: `${index % 2 !== 0 ? '#F9FAFB' : 'white'}` }}
                    >
                      <td className="w-4 p-4">
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            style={{ accentColor: '#1c64f2' }}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            checked={
                              selected && selected[rowsPerPage * (currentPage - 1) + index]
                                ? selected[rowsPerPage * (currentPage - 1) + index]
                                : false
                            }
                            onChange={(e) => {
                              setSelected({
                                ...selected,
                                [rowsPerPage * (currentPage - 1) + index]: e.target.checked,
                              });
                            }}
                          />
                          <label htmlFor="checkbox-table-1" className="sr-only">
                            checkbox
                          </label>
                        </div>
                      </td>
                      {columns?.map((column, index) => {
                        return column?.button == true ? (
                          <td className="px-6 py-4" key={index}>
                            {column.cell(item)}
                          </td>
                        ) : (
                          <td key={index} className="px-6 py-4">
                            {column.selector(item)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
            {/* <tfoot className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky bottom-0 z-10">
                        <tr>
                            <th colSpan={1} scope="col" className="p-4 text-center">
                                <div className="items-center">
                                    Tổng
                                </div>
                            </th>
                            {columns?.map((column, index) => {
                                return (
                                    <th key={index} scope="col" className="px-6 py-3">
                                        <div className="flex items-center">
                                            {column.name}
                                            {
                                                column.sort && <a href="#"><svg className="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                                </svg></a>
                                            }
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>
                    </tfoot> */}
          </table>
        )}
      </div>

      <div className="container-fluid">
        <Pagination
          rowsPerPage={rowsPerPage}
          rowCount={data?.length || 0}
          onChangePage={(newPage) => setCurrentPage(Number(newPage))}
          onChangeRowsPerPage={(newRowsPerPage) => {
            setRowsPerPage(newRowsPerPage);
            setCurrentPage(1);
          }}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
}
export default Table;
